import { defineMessages } from 'react-intl'


export default defineMessages({
  purposesDescription: {
    defaultMessage: 'Choose which purposes you consent to be used for the processing of data by TCF vendors',
    id: 'purposes-tab.purposes-description',
  },

  specialFeatures: {
    defaultMessage: 'Special Features',
    id: 'purposes-tab.special-features',
  },

  specialFeaturesDescription: {
    defaultMessage: 'Choose which features you consent to be used for the processing of data by TCF vendors',
    id: 'purposes-tab.special-features-description',
  },
})
